export default __webpack_public_path__ + "static/media/prom.6d358e78.png";